"use strict";
import DOMPurify from "dompurify";
const CSS_UNSAFE = /expression\s*\(|url\s*\(\s*['"]?\s*javascript:/i;
const STYLE_BLOCK_REGEX = /<style\b[^>]*>[\s\S]*?<\/style>/gi;
function isSafeStyleBlock(styleHtml) {
  const contentMatch = styleHtml.match(/<style\b[^>]*>([\s\S]*?)<\/style>/i);
  const cssContent = contentMatch ? contentMatch[1] : "";
  return !CSS_UNSAFE.test(cssContent);
}
function extractSafeStyleBlocks(html) {
  const safeStyles = [];
  const withoutStyles = html.replace(STYLE_BLOCK_REGEX, (match) => {
    if (isSafeStyleBlock(match)) safeStyles.push(match);
    return "";
  });
  return { withoutStyles, safeStyles: safeStyles.join("") };
}
export const EMAIL_PREVIEW_SANITIZER_CONFIG = {
  ALLOWED_TAGS: [
    "html",
    "head",
    "body",
    "meta",
    "title",
    "link",
    "style",
    "noscript",
    "div",
    "span",
    "center",
    "font",
    "eab-image-container",
    "p",
    "br",
    "hr",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "strong",
    "em",
    "b",
    "i",
    "u",
    "s",
    "strike",
    "small",
    "sub",
    "sup",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr",
    "td",
    "th",
    "colgroup",
    "col",
    "caption",
    "ul",
    "ol",
    "li",
    "dl",
    "dt",
    "dd",
    "blockquote",
    "pre",
    "code",
    "a",
    "img",
    "figure",
    "figcaption"
  ],
  ALLOWED_ATTR: [
    // Global
    "id",
    "class",
    "lang",
    "dir",
    "style",
    "role",
    "align",
    "valign",
    "bgcolor",
    "width",
    "height",
    "border",
    "cellpadding",
    "cellspacing",
    // Inline image processing
    "data-image-id",
    "data-attachment-id",
    // Personalized microsite mergefield widgets
    "data-name",
    "data-token",
    "data-step-microsite-id",
    // Links / media
    "href",
    "target",
    "rel",
    "src",
    "alt",
    "title",
    // Table
    "summary",
    "colspan",
    "rowspan",
    "abbr",
    "axis",
    "scope",
    "span",
    // Lists
    "start",
    "reversed",
    "type",
    // Metadata
    "charset",
    "content",
    "name",
    "http-equiv",
    "media",
    // Outlook namespace declarations
    "xmlns",
    "xmlns:o",
    "xmlns:v",
    "xmlns:w",
    // Font (legacy email)
    "color",
    "size",
    "face"
  ],
  ALLOW_DATA_ATTR: false,
  FORCE_BODY: false,
  WHOLE_DOCUMENT: false
};
export function sanitizeEmailPreviewHtml(html) {
  const { withoutStyles, safeStyles } = extractSafeStyleBlocks(html || "");
  const sanitizedBody = DOMPurify.sanitize(withoutStyles, EMAIL_PREVIEW_SANITIZER_CONFIG);
  return safeStyles + sanitizedBody;
}
